import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { ManageParcel } from './';

export default function ParcelTabs(props) {
  const { hideTabs, subscriptionGroup, alertTypes, updateParcels } = props;

  return (
    <Tabs defaultActiveKey="eAlerts">
      <Tab eventKey="eAlerts" title="Manage eAlerts">
        <ManageParcel
          hideTabs={hideTabs}
          subscriptionGroup={subscriptionGroup}
          alertTypes={alertTypes}
          updateParcels={updateParcels}
          key={subscriptionGroup.parcelNumber}
        />
      </Tab>
    </Tabs>
  );
}
